<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar dense class="indigo darken-1 headline" primary-title>
            <v-toolbar-title class="white--text">
              Prezzo/Costo
            </v-toolbar-title>
          </v-toolbar>
          <v-container class="mt-3" fluid>
            <v-row>
              <v-col cols="2">
                <v-text-field
                  dense
                  hide-details
                  type="number"
                  v-model.number="costo_standard"
                  label="Costo Industriale"
                  append-icon="mdi-currency-eur"
                ></v-text-field>
              </v-col>

              <v-col cols="2">
                <v-text-field
                  dense
                  hide-details
                  type="number"
                  v-model.number="prezzo_standard"
                  label="Prezzo Base"
                  append-icon="mdi-currency-eur"
                ></v-text-field>
              </v-col>

              <v-col cols="2">
                <v-text-field
                  dense
                  hide-details
                  type="number"
                  v-model.number="costo_imballo"
                  label="Costo Imballo"
                  append-icon="mdi-currency-eur"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  dense
                  hide-details
                  type="number"
                  v-model.number="costo_trasporto"
                  label="Costo Trasporto"
                  append-icon="mdi-currency-eur"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  dense
                  hide-details
                  v-model="tipo_costo"
                  :items="items_tipi_costo"
                  item-text="des"
                  item-value="id_tabella"
                >
                  <template #label>
                    <span class="">Tipo Costo</span>
                    <a @click.stop style="pointer-events: all">
                      <Modules
                        v-on:dialogModules="getTabella"
                        tipo="ARTICOLO_TIPO_COSTO"
                        nome="Tipo Costo"
                        setaction="settabelle"
                        getaction="gettabelle"
                        controller="Magazzino"
                        filter="validita = 1"
                        :dati="[{ des: '' }]"
                      />
                    </a>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <v-col cols="12">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">Costo</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn class="mr-5" disabled small>
              <v-icon color="primary">mdi-file-plus-outline</v-icon>
            </v-btn>
            <v-btn class="mr-5" disabled small>
              <v-icon color="primary">mdi-file-document-edit-outline</v-icon>
            </v-btn>
            <v-btn disabled small>
              <v-icon color="primary">mdi-file-remove</v-icon>
            </v-btn>

            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container class="mt-3" fluid>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  dense
                  label="Soggetto"
                  type="text"
                  v-model="soggetto"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  label="Ricerca"
                  type="text"
                  v-model="prefisso_lotto"
                ></v-text-field>
              </v-col>
              <v-col cols="1" align="left">
                <v-btn small>
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12">
                <v-data-table :headers="headers"></v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-container>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  components: {
    Modules: () => import("@/components/TOOLS/Modules"),
    SnackbarQV,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      costo_imballo: null,
      costo_standard: null,
      costo_trasporto: null,
      prefisso_lotto: "",
      prezzo_standard: null,
      soggetto: "",
      tipo_costo: null,

      // Modals
      caricamento_dati: false,

      // Array
      headers: [
        {
          text: "",
          value: "",
          align: "start",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des",
          sortable: false,
        },
        {
          text: "Codice",
          value: "codice",
          sortable: false,
        },
        {
          text: "Ragione Sociale",
          value: "Ragione Sociale",
          sortable: false,
        },
        {
          text: "Destinazione",
          value: "destinazione",
          sortable: false,
        },
        {
          text: "Fase",
          value: "fase",
          sortable: false,
        },
        {
          text: "Q.ta DA",
          value: "da_qty",
          sortable: false,
        },
        {
          text: "Q.ta A",
          value: "a_qty",
          sortable: false,
        },
        {
          text: "Prez. Unitario",
          value: "prez_uni",
          sortable: false,
        },
        {
          text: "Tipologia",
          value: "tipo",
          sortable: false,
        },
        {
          text: "Validata Da",
          value: "validata_da",
          sortable: false,
        },
        {
          text: "Validata A",
          value: "validata_a",
          sortable: false,
        },
        {
          text: "Note",
          value: "note",
          sortable: false,
        },
      ],
      items_tipi_costo: new Array(),
    };
  },
  watch: {
    "data.id_articolo": {
      immediate: true,
      handler() {
        this.costo_imballo = this.data.costo_imballo;
        this.costo_standard = this.data.costo_standard;
        this.costo_trasporto = this.data.costo_trasporto;
        this.prezzo_standard = this.data.prezzo_standard;
        this.tipo_costo = this.data.tipo_costo;
      },
    },
  },
  methods: {
    getTabella() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "ARTICOLO_TIPO_COSTO",
          filter: "validita = 1",
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.items_tipi_costo = res.data ? res.data : new Array();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server nel recuper dei lotti associati all'articolo."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server nel recuper dei lotti associati all'articolo."
          );
        });
    },
  },
  mounted() {
    this.getTabella();
  },
};
</script>

<style css scoped></style>
